import { render, staticRenderFns } from "./AdministratorRegisterOptinModal.vue?vue&type=template&id=5909a398&"
import script from "./AdministratorRegisterOptinModal.vue?vue&type=script&lang=js&"
export * from "./AdministratorRegisterOptinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CListIcon: require('@chakra-ui/vue').CListIcon, CListItem: require('@chakra-ui/vue').CListItem, CList: require('@chakra-ui/vue').CList, CBox: require('@chakra-ui/vue').CBox})
